/**
 * Position of `value` within `[min, max]`, expressed as a percentage number in
 * `[0, 100]` (no unit). Used to place the filled track, the value bubble and
 * tick marks. Out-of-range values are clamped; a degenerate range (`max <= min`)
 * yields `0`.
 */
export function computeFill(value: number, min: number, max: number): number {
  const span = max - min;
  if (span <= 0) return 0;
  const ratio = (value - min) / span;
  const clamped = Math.min(1, Math.max(0, ratio));
  return clamped * 100;
}
